export enum SocialErrorStatusEnum {
  CannotExtractEmailFromFacebook = 'cannot-extract-email-from-facebook',
  CannotExtractEmailFromGoogle = 'cannot-extract-email-from-google',
  Closed = 'CLOSED',
}
